import React from 'react';
import { HeaderGroup } from 'react-table';

interface RecordHeaderProps {
  table: any;           // Instancia de react-table
  showFilters?: boolean;
}

const RecordHeader: React.FC<RecordHeaderProps> = ({ table, showFilters }) => {
  const { headerGroups, setFilters } = table;

  return (
    <thead className="bg-gray-100 dark:bg-gray-800">
      {headerGroups.map((headerGroup: HeaderGroup<any>) => (
        <React.Fragment key={headerGroup.id}>
          {/* 🔹 Encabezados */}
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column: any) => (
              <th
                key={column.id}
                {...column.getHeaderProps(column.getSortByToggleProps())}
                className={`text-gray-800 dark:text-gray-200 py-4 text-left text-sm font-semibold sm:text-base ${
                  column.id === 'rowIndex'
                    ? 'w-[70px] px-2 text-center'
                    : 'px-5'
                }`}
              >
                <div className="flex items-center">
                  {column.render('Header')}
                  <div className="ml-2 inline-flex flex-col space-y-[2px]">
                    <span className="inline-block">
                      <svg
                        className="fill-current"
                        width="10"
                        height="5"
                        viewBox="0 0 10 5"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5 0L0 5H10L5 0Z" />
                      </svg>
                    </span>
                    <span className="inline-block">
                      <svg
                        className="fill-current"
                        width="10"
                        height="5"
                        viewBox="0 0 10 5"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M5 5L10 0L0 0L5 5Z" />
                      </svg>
                    </span>
                  </div>
                </div>
              </th>
            ))}
          </tr>

          {/* 🔹 Filtros */}
          {showFilters && (
            <tr>
              {headerGroup.headers.map((column: any) => (
                <th key={column.id} className="px-5 py-2">
                  <input
                    type="text"
                    placeholder={column.id === 'rowIndex' ? '' : 'Buscar...'}
                    disabled={column.id === 'rowIndex'}
                    title={
                      column.id === 'rowIndex'
                        ? 'No se puede filtrar por número de fila'
                        : ''
                    }
                    className={`${
                      column.id === 'rowIndex' ? 'max-w-[60px]' : 'w-full'
                    } rounded-lg border-[1.5px] border-stroke bg-transparent px-5 py-3 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary dark:disabled:bg-black`}
                    onChange={(e) =>
                      setFilters((prev: any) => ({
                        ...prev,
                        [column.id]: e.target.value,
                      }))
                    }
                  />
                </th>
              ))}
            </tr>
          )}
        </React.Fragment>
      ))}
    </thead>
  );
};

export default RecordHeader;
